module.exports = __webpack_public_path__ + "img/fear.f728ffb7.svg";